import { memo } from 'react'

import BuildingBlocks, { TEST_ID } from './BuildingBlocks'

const BuildingBlocksComponent = memo(BuildingBlocks)

export { TEST_ID }

export default BuildingBlocksComponent
